'use client'

const defaultProps = {
  variant: "section",
  a11yLabel: "Loading",
  sectionHeight: 160,
  textVariant: "body.base"
};
export {
  defaultProps
};
